import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { addMonths, format, isSameMonth, startOfMonth } from 'date-fns';
import { first } from 'lodash';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var FcYearMonthInputComponent = /** @class */ (function () {
    function FcYearMonthInputComponent(fuseTranslationLoaderService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.showSearchIcon = false;
        this.requiredMark = false;
        this.label = null;
        this.values = [];
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.search = this.search.bind(this);
        this.displayWith = this.displayWith.bind(this);
    }
    FcYearMonthInputComponent.prototype.ngOnInit = function () {
        this.minDate = startOfMonth(this.minDate);
        this.maxDate = startOfMonth(this.maxDate);
        var current = this.minDate;
        while (true) {
            this.values.push({
                name: current.toLocaleString('default', { month: 'long', year: 'numeric' }).replace(/^\w/, function (c) { return c.toUpperCase(); }),
                value: format(current, 'yyyy-MM')
            });
            if (isSameMonth(current, this.maxDate)) {
                break;
            }
            current = addMonths(current, 1);
        }
        this.values = this.values.reverse();
        var firstValue = first(this.values);
        if (firstValue && !this.control.value) {
            this.control.setValue(firstValue);
        }
    };
    FcYearMonthInputComponent.prototype.search = function (searchTerm) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                searchTerm = (searchTerm.toLowerCase() || '').trim();
                return [2 /*return*/, this.values.filter(function (item) {
                        return item.name.toLowerCase().includes(searchTerm) || item.value.toLowerCase().includes(searchTerm);
                    })];
            });
        });
    };
    FcYearMonthInputComponent.prototype.displayWith = function (value) {
        return value && value.name;
    };
    return FcYearMonthInputComponent;
}());
export { FcYearMonthInputComponent };
